import fetchClient from "api/client";
import SCHEDULED_REPORTS_ENDPOINT from "./scheduledReportsEndpoint";

/**
 * @description POST api/report-schedules/:reportId/duplicate
 * */
export default function duplicateScheduledReport(reportId) {
  if (!reportId) {
    return Promise.reject(new Error("Report ID is required."));
  }

  const url = `${SCHEDULED_REPORTS_ENDPOINT}/${reportId}/duplicate`;

  return fetchClient.post(url);
}
